import { render } from "./PopUpObservationSimple.vue?vue&type=template&id=0238829c"
import script from "./PopUpObservationSimple.vue?vue&type=script&lang=js"
export * from "./PopUpObservationSimple.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__